import { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";

const whatsappNumber = (
 process.env.REACT_APP_WHATSAPP_NUMBER || "918800702886"
).replace(/\D/g, "");

export default function FloatingWhatsApp() {
 const [visible, setVisible] = useState(false);

 useEffect(() => {
  const timer = window.setTimeout(() => setVisible(true), 2000);
  return () => window.clearTimeout(timer);
 }, []);

 if (!visible || !whatsappNumber) return null;

 const message = encodeURIComponent(
  "Hello Mozo EV, I want to enquire about EV battery products.",
 );

 return (
  <a
   href={`https://wa.me/${whatsappNumber}?text=${message}`}
   target="_blank"
   rel="noreferrer"
   aria-label="Chat with Mozo EV on WhatsApp"
   className="fixed bottom-5 right-4 z-50 grid h-14 w-14 place-items-center rounded-full bg-[#25D366] text-[30px] text-white shadow-[0_16px_38px_rgba(37,211,102,0.35)] ring-4 ring-white/90 transition hover:-translate-y-1 hover:scale-105 hover:bg-[#1ebe5d] sm:bottom-6 sm:right-6 sm:h-16 sm:w-16 sm:text-[34px]"
  >
   <FaWhatsapp />
   <span className="absolute -bottom-1 rounded-full bg-white px-2 py-0.5 text-[9px] font-bold uppercase tracking-wide text-[#128C7E] shadow-sm sm:text-[10px]">
    Chat
   </span>
  </a>
 );
}
